/* eslint-disable brace-style */
class HeroHotspots extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['hotspot', 'tooltip']
  }

  static get requiredExternalElements () {
    return ['slide']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.positionTooltips()

    this.listeners.add(
      window,
      'resize',
      this.debounce(() => {
        this.positionTooltips()
      }, 200),
    )

    this.setupCarouselObserver()
  }

  setupCarouselObserver () {
    this.carouselObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-slide' &&
          document.querySelector('.sec-HeroSlide_Hotspot')
        ) {
          this.positionTooltips()
        }
      })
    })

    if (this.externalEls.slide.elements.length > 0) {
      this.externalEls.slide.elements.forEach(slide => {
        this.carouselObserver.observe(slide, { attributes: true })
      })
    }
  }

  positionTooltips () {
    this.els.hotspot.elements.forEach((hotspot, index) => {
      hotspot.removeAttribute('data-tooltip-position')
      const tooltip = this.els.tooltip.elements[index]
      const rect = hotspot.getBoundingClientRect()
      const tooltipRect = tooltip.getBoundingClientRect()
      const sectionViewportRect = this.externalEls.slide.element.getBoundingClientRect()
      const sectionViewportWidth = sectionViewportRect.width
      const sectionViewportHeight = sectionViewportRect.height

      if (!tooltip) return

      let position = 'top'

      if (rect.left + tooltipRect.width / 2 < sectionViewportWidth * 0.1) {
        position = 'right'
      } else if (
        rect.right - tooltipRect.width / 2 >
        sectionViewportWidth * 0.9
      ) {
        position = 'left'
      } else if (rect.top < sectionViewportHeight * 0.3) {
        position = 'bottom'
      }
      hotspot.setAttribute('data-tooltip-position', position)
    })
  }

  debounce (func, wait) {
    let timeout
    return function executedFunction (...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    if (this.carouselObserver) {
      this.carouselObserver.disconnect()
    }
  }
}

customElements.define('hero-hotspot', HeroHotspots)
